import React, { useState } from "react";
import Button from "../../../forms/Button";
import useFetch from "../../../../hooks/useFetch";
import {
  CreatePayment,
  subscriptionListFont,
} from "../../../../services/subscriptionService";
import StripePayment from "../../../../pages/front/account/StripePayment";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import useMutation from "../../../../hooks/useMutation";
import { toast } from "react-toastify";
import { getCartList, placeOrder } from "../../../../services/cartService";
import { clearCart } from "../../../../redux/slice/cartSlice";
import { useDispatch } from "react-redux";

const SubscriptionSummary = ({
  hideButton = false,
  shippingAddress,
  billingAddress,
  sameAsShipping,
}) => {
  // const subscriptiondata = {
  //   numberOfPages: 30,
  //   subscriptionName: "Premium Doodle",
  //   subscriptionAmount: 39.99,
  //   subscriptionFeatures: [{ feature: "Up to 40 photos" }, { feature: "Premium hard cover" }, { feature: "Coloring tips page" }, { feature: "Black & white line art" }, { feature: "Full customization options" }],
  // };
  const { data: subscriptionData } = useFetch({
    dependencies: ["dashboardSubscription"],
    fetchFunction: async () => {
      const res = await subscriptionListFont();
      if (res?.docs?.status === 200) {
        return res?.docs?.data || [];
      }
      return [];
    },
  });
  const subscriptiondata = subscriptionData?.[0];
  // console.log(subscriptiondata, "sdd");

  const [stripeData, setStripeData] = useState({
    clientSecret: "",
    intentId: "",
  });
  const [isPaying, setIsPaying] = useState(false);
  // const handlePlaceOrder = async () => {
  //   try {
  //     setIsPaying(true);
  //     const res = await CreatePayment({
  //       planId: subscriptiondata?.planData?._id,
  //     });
  //     if (res?.status === 200) {
  //       console.log(res?.data, "gyvgy");
  //       setStripeData(res.data);
  //     }
  //   } catch (error) {
  //     console.error("Payment creation failed:", error);
  //   } finally {
  //     setIsPaying(false);
  //   }
  // };
  const navigate = useNavigate();
  // const handlePlaceOrder = async () => {
  //   try {
  //     setIsPaying(true);
  //     const res = await CreatePayment({
  //       planId: subscriptiondata?.planData?._id,
  //     });

  //     if (res?.status === 200) {
  //       const { clientSecret, intentId } = res.data;

  //       // ✅ Navigate to /payment and pass data
  //       navigate("/payment", {
  //         state: { clientSecret, intentId },
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Payment creation failed:", error);
  //   } finally {
  //     setIsPaying(false);
  //   }
  // };

  //place order
  const dispatch = useDispatch();
  const cartData = useSelector((state) => state.cart.cartListData?.data || []);
  const {
    data: cart = {},
    // isLoading,
    // refetch,
  } = useFetch({
    dependencies: ["cart"],
    fetchFunction: async () => {
      const query = {};

      const res = await getCartList(query);
      return res?.docs || {};
    },
  });
  // console.log(cartData, "cd");
  const { mutate, isPending } = useMutation({
    mutationFn: placeOrder,
    onSuccess: (res) => {
      if (res?.status === 200) {
        toast.success(res?.message || "Order placed!");
        dispatch(clearCart());

        navigate("/thank-you", {
          state: { orderId: res?.data?.data?.orderId },
        });
      } else {
        toast.error(res?.message || "Order failed.");
      }
    },
    onError: (err) => {
      console.error("Order Failed", err);
    },
  });

  const handlePlaceOrder = () => {
    // console.log(shippingAddress, "sa", billingAddress, "BA", cartData?.length);
    const finalBillingAddress = sameAsShipping
      ? shippingAddress
      : billingAddress;
    if (!shippingAddress || !finalBillingAddress || !cartData?.length) {
      alert(
        "Please select both addresses or check Same as Shipping or missing CartData."
      );
      return;
    }
    const bookTitle = cart?.data?.[0]?.bookData?.title;
    const bookDescription = cart?.data?.[0]?.bookData?.description;
    const items = cartData.map((item) => ({
      productId: item?.product?._id,
      quantity: item?.quantity,
    }));
    // console.log(bookTitle, "BT", items, "iT", cartData[0], "CD");
    const formatAddress = (addr) => ({
      name: addr?.name,
      email: addr?.email,
      phone: addr?.phone,
      address1: addr?.addressLine1,
      address2: addr?.addressLine2,
      city: "", // Optional if not stored
      state: "",
      postalCode: "",
      country: "",
    });

    const payload = {
      bookTitle,
      bookDescription,
      items,
      billingAddress: formatAddress(billingAddress),
      shippingAddress: formatAddress(shippingAddress),
    };

    mutate(payload);
  };

  return (
    <>
      <div className="relative bg-white py-4 px-4 shadow shadow-md-pink/20 rounded-lg">
        <div className="mb-4 pb-4 border-b border-md-pink-light-1 flex items-center justify-between gap-4 flex-wrap">
          <div className="text-lg 2xl:text-xl text-md-dark font-semibold">
            Plan Summary
          </div>
        </div>
        <div className="relative space-y-6">
          <div class="flex items-start gap-3 2xl:gap-4 3xl:gap-6">
            <div class="flex-shrink-0 text-2xl 2xl:text-4xl w-12 2xl:w-16 aspect-square flex items-center justify-center rounded-lg shadow-lg shadow-md-green/20 transition-all duration-300 text-white bg-md-green">
              <i class="fa-fw fa-light fa-tickets-perforated"></i>
            </div>
            <div class="flex justify-between gap-4 flex-wrap">
              <div class="space-y-0.5 w-full">
                <div class="text-[10px] 2xl:text-xs uppercase !leading-none text-slate-400 tracking-wide">
                  Plan
                </div>
                <div class="text-sm 2xl:text-base font-medium !leading-none">
                  {subscriptiondata?.planData?.name}
                </div>
              </div>
              {/* <div class="space-y-0.5">
                <div class="text-[10px] 2xl:text-xs uppercase !leading-none text-slate-400 tracking-wide">
                  Pages
                </div>
                <div class="text-sm 2xl:text-base font-medium !leading-none">
                  {subscriptiondata?.numberOfPages +
                    (subscriptiondata?.numberOfPages > 1 ? " pages" : " page")}
                </div>
              </div> */}
              {/* <div class="space-y-0.5">
                <div class="text-[10px] 2xl:text-xs uppercase !leading-none text-slate-400 tracking-wide">
                  Amount
                </div>
                <div class="text-sm 2xl:text-base font-medium !leading-none">
                  {"$" + subscriptiondata?.subscriptionAmount}
                </div>
              </div> */}
              <div class="space-y-0.5 w-full">
                <div class="text-[10px] 2xl:text-xs uppercase !leading-none text-slate-400 tracking-wide">
                  Details
                </div>
                {subscriptiondata?.planData?.features?.length > 0 && (
                  <div className="text-xs 2xl:text-sm text-slate-500">
                    <ul className="3xl:columns-2 list-disc list-outside pl-4">
                      {subscriptiondata?.planData?.features?.map(
                        (item, index) => (
                          <li key={index}>{item?.name}</li>
                        )
                      )}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-4 pt-4 border-t border-md-pink-light-1 flex items-start justify-between gap-4">
          <div className="w-full flex-shrink-0 flex items-center gap-1 md:gap-2">
            {!hideButton && (
              <Button
                buttonHasLink={false}
                buttonLabel={isPending ? "Placing..." : "Place Order"}
                buttonClasses={"!w-full !rounded-md"}
                buttonLabelClasses={"!font-medium !pb-1 !leading-none !text-xl"}
                buttonFunction={handlePlaceOrder}
                disabled={isPending}
              />
            )}
            {/* <Button
              buttonHasLink={false}
              buttonLabel={isPaying ? "Processing..." : "Place Order"}
              buttonClasses={"!w-full !rounded-md"}
              buttonLabelClasses={"!font-medium !pb-1 !leading-none !text-xl"}
              buttonFunction={handlePlaceOrder}
              disabled={isPaying}
            /> */}
            {/* {stripeData.clientSecret && stripeData.intentId && (
              <div className="mt-6">
                <StripePayment
                  clientSecret={stripeData.clientSecret}
                  intentId={stripeData.intentId}
                />
              </div>
            )} */}
          </div>
        </div>
      </div>
    </>
  );
};

export default SubscriptionSummary;
